module.exports = __webpack_public_path__ + "5255b6e5ffcee7134d2ef2092281cdde.png";